module.exports = __webpack_public_path__ + "static/media/plus.cf81b6a4.svg";